import { render, staticRenderFns } from "./Layer3Service.vue?vue&type=template&id=2aba39f0&"
import script from "./Layer3Service.vue?vue&type=script&lang=js&"
export * from "./Layer3Service.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports